/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExplainedAccessLevel,
  ExplainedAccessLevel$inboundSchema,
} from "./explainedaccesslevel.js";

/**
 * Who may connect without a rule. public: connecting is not checked against rules. private: rules decide. disabled: nobody can connect.
 */
export const Visibility = {
  Public: "public",
  Private: "private",
  Disabled: "disabled",
} as const;
/**
 * Who may connect without a rule. public: connecting is not checked against rules. private: rules decide. disabled: nobody can connect.
 */
export type Visibility = ClosedEnum<typeof Visibility>;

export type ExplainResourceAccessResult = {
  /**
   * The decision for use, view and manage, in that order.
   */
  levels: Array<ExplainedAccessLevel>;
  /**
   * Who may connect without a rule. public: connecting is not checked against rules. private: rules decide. disabled: nobody can connect.
   */
  visibility: Visibility;
};

/** @internal */
export const Visibility$inboundSchema: z.ZodMiniEnum<typeof Visibility> = z
  .enum(Visibility);

/** @internal */
export const ExplainResourceAccessResult$inboundSchema: z.ZodMiniType<
  ExplainResourceAccessResult,
  unknown
> = z.object({
  levels: z.array(ExplainedAccessLevel$inboundSchema),
  visibility: Visibility$inboundSchema,
});

export function explainResourceAccessResultFromJSON(
  jsonString: string,
): SafeParseResult<ExplainResourceAccessResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExplainResourceAccessResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExplainResourceAccessResult' from JSON`,
  );
}
